'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var ThrowNoJsonLoaderError = exports.ThrowNoJsonLoaderError = function ThrowNoJsonLoaderError() {
  if (process.env.NODE_ENV !== 'production') {
    var webpackSignatures = [typeof __webpack_require__ === 'undefined' ? 'undefined' : _typeof(__webpack_require__), typeof __webpack_modules__ === 'undefined' ? 'undefined' : _typeof(__webpack_modules__)];

    var isWebpackOne = webpackSignatures[0] !== 'undefined' || webpackSignatures[1] !== 'undefined';

    var message = 'react-flag-icon-css needs to import json files';
    var suggestion = isWebpackOne ? ' update to Webpack 2 to load json out of the box or add ' + 'https://github.com/webpack/json-loader and this in your Webpack ' + 'configuration: { test: /\\.json$/, loader: "json-loader" }' : ' add/configure the json loader or plugin for your module bundler.';

    throw new Error(message + ':' + suggestion);
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/react-flag-icon-css/lib/functions/config.js
// module id = 801
// module chunks = 0